import { SharingData } from '../../schema/SharingData';
import { isAfter, now } from 'owa-datetime';

export function isExpiring(sharingData: SharingData): boolean {
    return (
        sharingData &&
        sharingData.sharingInfo &&
        !!sharingData.sharingInfo.expirationDate &&
        isAfter(sharingData.sharingInfo.expirationDate, now())
    );
}
